import { useReveal } from "@/hooks/useReveal";

const steps = [
  {
    n: "01",
    title: "Anfrage",
    text: "Sie melden sich per Telefon, WhatsApp, E-Mail oder über das Kontaktformular. Sagen Sie einfach, wann und wofür Sie den Tesla nutzen möchten.",
  },
  {
    n: "02",
    title: "Beratung",
    text: "Wir klären gemeinsam alle Fragen zu Fahrzeug, Zeitraum und Konditionen – ehrlich, transparent und passend zu Ihrem Vorhaben.",
  },
  {
    n: "03",
    title: "Umsetzung",
    text: "Persönliche Übergabe mit ausführlicher Einweisung – dann heißt es: elektrisch losfahren. Auch während der Miete bleiben wir erreichbar.",
  },
];

export const Process = () => {
  useReveal();
  return (
    <section id="ablauf" data-testid="process-section" className="py-24 md:py-32 bg-black border-y border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl reveal mb-16">
          <p className="text-xs uppercase tracking-[0.25em] text-white/40 mb-4">
            Ablauf
          </p>
          <h2 className="font-heading font-bold text-white tracking-tight text-3xl md:text-4xl lg:text-5xl leading-tight">
            In drei Schritten hinters Steuer.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {steps.map((s, i) => (
            <div
              key={s.n}
              data-testid={`process-step-${i}`}
              className="reveal relative rounded-2xl border border-white/10 bg-card p-8 md:p-10 overflow-hidden hover:border-white/25 transition-colors"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <span className="absolute -top-4 right-4 font-heading text-8xl font-extrabold text-white/5 select-none">
                {s.n}
              </span>
              <p className="font-heading text-sm tracking-[0.2em] text-white/40 mb-6">
                SCHRITT {s.n}
              </p>
              <h3 className="font-heading font-semibold text-2xl text-white mb-3">
                {s.title}
              </h3>
              <p className="text-sm text-white/60 leading-relaxed relative z-10">
                {s.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
